import { fabric } from 'fabric'

export const generateClipPath = (parent: fabric.Object) => {
    const options = {
        originX: 'center',
        originY: 'center',
        fill: 'transparent',
        absolutePositioned: true,
        centeredScaling: true,
        data: { size: parent.data.size },
    }

    if (parent instanceof fabric.Circle) {
        return new fabric.Circle({
            top: parent.top,
            left: parent.left,
            width: parent.width,
            height: parent.height,
            radius: parent.radius,
            angle: parent.angle,
            ...options,
        })
    } else if (parent instanceof fabric.Rect) {
        return new fabric.Rect({
            top: parent.top,
            left: parent.left,
            width: parent.width,
            height: parent.height,
            angle: parent.angle,
            ...options,
        })
    } else if (parent instanceof fabric.Ellipse) {
        return new fabric.Ellipse({
            top: parent.top,
            left: parent.left,
            width: parent.width,
            height: parent.height,
            angle: parent.angle,
            rx: parent.rx,
            ry: parent.ry,
            ...options,
        })
    } else if (parent instanceof fabric.Polygon) {
        return new fabric.Polygon(parent.points ?? [], {
            top: parent.top,
            left: parent.left,
            width: parent.width,
            height: parent.height,
            angle: parent.angle,
            ...options,
        })
    }
}
